import axios from "axios";
import jwt_decode from "jwt-decode";
import dayjs from 'dayjs';


const refresh_token_url = 'token/refresh/';

const loginConfig = {
    baseURL: 'https://cabinet.ttc.kz/api/v1/',
    headers: {
        'Content-Type': 'application/json'
    }
}

const defaultConfig = {
    baseURL: 'https://cabinet.ttc.kz/api/v1/',
    headers: {
        'Content-Type': 'application/json'
    }
}

const LoginAPIInstance = axios.create(loginConfig);
const DefaultAPIInstance = axios.create(defaultConfig);

// let refreshError = false

DefaultAPIInstance.interceptors.request.use( 
    request => {
        const refreshToken = localStorage.getItem('refresh-token')
        if (!refreshToken || dayjs.unix(jwt_decode(refreshToken).exp).diff(dayjs()) < 1){
            localStorage.removeItem('access-token') 
            localStorage.removeItem('refresh-token') 
            localStorage.removeItem('userId')
            delete DefaultAPIInstance.defaults.headers.common['Authorization']
            location.reload()
        }
        return request
    },
    (error) => {
        return Promise.reject(error);
    }
);

DefaultAPIInstance.interceptors.response.use( response => response,
    async function (error) {
    // const status = error.response ? error.response.status : null
    const originalRequest = error.config
    if (error.response.status === 401) {
        
        // console.log(error)
        // localStorage.removeItem('access-token') 
        // delete DefaultAPIInstance.defaults.headers.common['Authorization']
        // refresh = true
        const {data, status} = await DefaultAPIInstance.post(refresh_token_url, {"refresh": localStorage.getItem('refresh-token')});
        // if (status && status === 200){
            localStorage.setItem('access-token', `Bearer ${data.access}`)
            originalRequest.headers['Authorization'] = 'Bearer ' + data.access
            const retryOrigReq = DefaultAPIInstance(originalRequest)
            // refreshError = false
            return retryOrigReq;
        // }
        //     console.log('ref 401')
        //         window.history.pushState('/login')
        //     refreshError = true
        //     return
        
            // if (status !== 200){
            //     console.log('ref 401')
            //     window.history.pushState('/login')
            //     return
            // }
        // if (status === 200) {
            // console.log(data.access)
            // DefaultAPIInstance.defaults.headers.common['Authorization'] = `Bearer ${data.access}`
            
            // error.config.headers.Authorization = `Bearer ${data.access}`
            // console.log(DefaultAPIInstance.defaults.headers.common['Authorization'])
            
            
        // }
        
    }else if(error.response.status === 404){

    }
    // refresh = false
    
    return Promise.reject(error);
});

export {LoginAPIInstance, DefaultAPIInstance}